import request from '@/utils/request'

export function getDictTypeList(params = {}) {
  return request({ url: '/system/dict-type/page', method: 'get', params })
}
export function getDictType(id) {
  return request({ url: '/system/dict-type/get', method: 'get', params: { id } })
}
export function createDictType(data) {
  return request({ url: '/system/dict-type/create', method: 'post', data })
}
export function updateDictType(data) {
  return request({ url: '/system/dict-type/update', method: 'put', data })
}
export function deleteDictType(id) {
  return request({ url: '/system/dict-type/delete', method: 'delete', params: { id } })
}
export function getDictTypeSimpleList() {
  return request({ url: '/system/dict-type/list-all-simple', method: 'get' })
}

export function getDictDataList(params = {}) {
  return request({ url: '/system/dict-data/page', method: 'get', params })
}
export function getDictData(id) {
  return request({ url: '/system/dict-data/get', method: 'get', params: { id } })
}
export function createDictData(data) {
  return request({ url: '/system/dict-data/create', method: 'post', data })
}
export function updateDictData(data) {
  return request({ url: '/system/dict-data/update', method: 'put', data })
}
export function deleteDictData(id) {
  return request({ url: '/system/dict-data/delete', method: 'delete', params: { id } })
}
export function getDictItems(dictCode) {
  return request({ url: '/system/dict-data/list-all-simple', method: 'get', params: { dictType: dictCode } })
}
export function getAllDict() {
  return request({ url: '/system/dict-data/all', method: 'get' })
}

// 兼容旧调用方
export const getDictList = getDictDataList
export const getDictDetail = getDictData
export const createDict = createDictData
export const updateDict = (id, data) => updateDictData({ ...data, id })
export const deleteDict = deleteDictData
